import apiClient from './api'

export default {
  list(page = 1, perPage = 25, q = '') {
    return apiClient.get('/admin/heuristic-rules', {
      params: { page, per_page: perPage, q: q || undefined, sort_by: 'confidenceScore', sort_order: 'desc' },
    })
  },
  remove(id) {
    return apiClient.delete(`/admin/heuristic-rules/${id}`)
  },
}
